<template>
<e-chart ref="chart" />
</template>

<script>
export default {
  name: 'DataStatisticsChart',
  props: {
    data: {
      required: true,
      type: Array
    }
  },
  methods: {
    render (isReal) {
      let chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        tooltip: {},
        series: [{
          type: 'gauge',
          axisLine: {
            lineStyle: {
              width: 30,
              color: [
                [0.3, '#f6f6f6'],
                [0.8, '#E6A23C'],
                [1, '#67C23A']
              ]
            }
          },
          pointer: {
            itemStyle: {
              color: 'auto'
            }
          },
          axisTick: {
            distance: -30,
            length: 8,
            lineStyle: {
              color: '#fff',
              width: 2
            }
          },
          splitLine: {
            distance: -30,
            length: 30,
            lineStyle: {
              color: '#fff',
              width: 4
            }
          },
          axisLabel: {
            color: 'auto',
            distance: 40,
            fontSize: 14
          },
          detail: {
            valueAnimation: true,
            formatter: '{value}',
            color: 'auto'
          },
          data: this.data
        }]
      }

      this.$refs.chart.setOpt(chartOpt)
      this.$refs.chart.resize()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/DataStatisticsChart.vue